<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <defs>
            <pattern :id="patternId" patternUnits="userSpaceOnUse" width="16" height="16">
                <path d="M-3.75,0 L12.25,16" stroke="currentColor" stroke-width="3" />
                <path d="M3.75,0 L19.75,16" stroke="currentColor" stroke-width="3" />
            </pattern>
        </defs>

        <circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" stroke-width="2" />
        <circle cx="8" cy="8" r="7" :fill="`url(#${patternId})`" />
    </svg>
</template>

<script setup lang="ts">
import { useId } from 'vue';

type OptionallyOccupiedIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<OptionallyOccupiedIconProps>();
const patternId = useId();
</script>
